/** @jsx jsx */
import React, { useState } from 'react';
import { jsx } from 'theme-ui';
import Modal from 'react-modal';
import { FaTimes } from 'react-icons/fa';
import { isBrowser } from '../../helpers/isBrowser';

const DonateEmbryoButton = ({ style }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  function openModal(content) {
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  const continueToApplication = () => {
    isBrowser && (window.location.href = 'https://login.embryodonation.org/auth/registration');
  };
  return (
    <>
      <button
        title="Donate Embryo"
        sx={{
          display: 'block',
          my: '1rem',
          fontSize: '1rem',
          color: ' #000 !important',
          p: '1rem 1.5rem !important',
          borderRadius: '8px',
          textAlign: 'center',
          minWidth: '175px',
          border: '1px solid #AAD2D1',
          '&:hover': {
            background: ' transparent',
            color: ' #F7A496 !important',
          },
          ...style,
        }}
        onClick={openModal}
      >
        Donate Embryos
      </button>
      <div
        sx={{
          display: 'none',
          '.modal-container': {
            display: 'flex',
            flexDirection: 'column',
            header: {
              display: 'flex',
              justifyContent: 'space-between',
              padding: '0 0.5rem',
            },
          },
        }}
      >
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)',
              zIndex: '99998',
            },
            content: {
              zIndex: '99999',
              top: '55%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              overflowY: 'auto',
              maxHeight: '80vh',
              maxWidth: '1024px',
              // fontFamily: ' Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol,system-ui, -apple-system, BlinkMacSystemFont, Noto Color Emoji',
              padding: '2rem',
            },
          }}
        >
          <header
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              mb: '1rem',
            }}
          >
            IMPORTANT!
            <button onClick={closeModal} sx={{}}>
              <FaTimes />
            </button>
          </header>
          <div sx={{ p: { my: '1rem' } }}>
            <p>
              {' '}
              You are about to enter the application to donate embryos through the NEDC. There is no ‘submit’ button at the end of the process. Simply fill out all the form fields, and you will then be contacted by the NEDC via email about next steps within a few days.
            </p>
          </div>
          <div
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '1rem',
              flexWrap: 'wrap',
              justifyContent: 'center',
              my: '1rem',
              button: {
                display: 'block',
                fontSize: '1.25rem',
                fontWeight: 600,
                color: ' #FFFFFF !important',
                p: '1rem 1.5rem !important',
                background: ' #F7A496',
                borderRadius: '8px',
                textAlign: 'center',
                minWidth: '175px',
                border: '1px solid #F7A496',
                transition: 'all 0.35s',
                '&:hover:not(:disabled)': {
                  background: ' transparent',
                  color: ' #F7A496 !important',
                },
              },
              'button:disabled': {
                opacity: '0.5',
                cursor: 'not-allowed',
              },
            }}
          >
            <button onClick={continueToApplication}>
              Continue to the Application
            </button>
            <p>
              Already have an account?{' '}
              <a href="https://login.embryodonation.org/auth/login">Login</a>
            </p>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default DonateEmbryoButton;
